<script>
import ProjectBudgetService from "@/services/ProjectBudgetService";
import VoucherCategoryService from "@/services/VoucherCategoryService";

export default {
    data() {
        return {
            loading: true,
            importing: false,
            saving: false,
            savingResult: null,
            v_cats: [],
            uploading: false,
            importResult: null,
            isLoaded: false
        };
    },
    async created() {
        await this.fetchVoucherCategories();
        this.loading = false;
    },
    methods: {
        actionCancel() {
            this.importResult = false;
            this.isLoaded = false;
            this.savingResult = null;
        },
        async actionImport() {
            console.log("Running import");
            try {
                this.saving = true;
                const { data } = await ProjectBudgetService.POST_executeImport(
                    this.importResult.cache_key
                );

                this.savingResult = data.data;
            } catch (e) {
                console.log("err", e);
            }
            this.saving = false;
        },
        async fetchVoucherCategories() {
            try {
                const { data } = await VoucherCategoryService.GET_dropdown();
                this.v_cats = data.data;
            } catch (e) {
                console.log("error vc", e);
            }
        },
        /**
         * Perform the import
         * @param event
         */
        async importBudgets(event) {
            this.importing = true;
            const file = event.target.files[0];
            if (!file) return;

            const formData = new FormData();
            formData.append("file", this.$refs.file.files[0]);

            try {
                const { data } = await ProjectBudgetService.UPLOAD_file(
                    formData
                );
                this.importResult = data.data;
                this.isLoaded = true;
                this.importing = false;
            } catch (err) {
                console.error("Upload failed:", err);
            }
        }
    }
};
</script>

<template>
    <div>
        <base-header class="pb-1" type="">
            <bread-bag></bread-bag>
        </base-header>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12" v-if="!isLoaded">
                    <card>
                        <p>
                            {{
                                $t("pbudgets.lead_text_select_file_for_import")
                            }}
                        </p>
                        <v-loader v-if="importing" :loading="importing" />
                        <input
                            v-else
                            @change="importBudgets"
                            type="file"
                            name="file"
                            ref="file"
                        />
                    </card>
                </div>

                <template v-if="isLoaded">
                    <div class="col-12">
                        <card>
                            <p>{{ $t("pbudgets.lead_import_text") }}</p>

                            <div
                                class="text-center"
                                v-if="savingResult === null"
                            >
                                <base-button
                                    type="secondary"
                                    @click="actionCancel"
                                    >{{ $t("cancel") }}</base-button
                                >
                                <base-button
                                    type="primary"
                                    :loading="saving"
                                    @click="actionImport"
                                    >{{ $t("save") }}</base-button
                                >
                            </div>
                            <div v-else>
                                <div v-if="saving">
                                    {{ $t("pbudgets.saving") }}
                                    <div>
                                        <v-loader
                                            v-if="saving"
                                            :loading="saving"
                                        />
                                    </div>
                                </div>
                                <div v-else>
                                    <div
                                        class="alert alert-danger"
                                        v-if="savingResult.imported === false"
                                    >
                                        {{
                                            $t(
                                                "pbudgets.import_unsuccessful_sth_went_wrong"
                                            )
                                        }}
                                    </div>
                                    <div
                                        class="alert alert-success alert-outline"
                                        v-if="savingResult.imported === true"
                                    >
                                        {{ $t("pbudgets.imported") }}
                                    </div>
                                    <div class="mt-3 text-center">
                                        <base-button
                                            @click="actionCancel"
                                            size="sm"
                                            type="default"
                                            outline
                                            >{{
                                                $t("pbudgets.continue")
                                            }}</base-button
                                        >
                                    </div>
                                </div>
                            </div>
                        </card>
                    </div>
                    <div
                        class="col-12"
                        v-for="(pd, p_id) in importResult.parsed"
                    >
                        <card>
                            <h3>{{ pd.project_title }}</h3>

                            <div
                                v-if="p_id in importResult.validation"
                                class="text-danger"
                            >
                                {{
                                    $t(
                                        "pbudgets.missing_categories_in_the_budget_file"
                                    )
                                }}:
                                <ul>
                                    <li
                                        v-for="(n, i) in importResult[
                                            'validation'
                                        ][p_id]"
                                    >
                                        {{ n }}
                                        <span class="text-warning"
                                            >ID: {{ i }}</span
                                        >
                                    </li>
                                </ul>
                            </div>

                            <v-table class="table table-sm table-striped">
                                <v-thead>
                                    <v-tr>
                                        <v-th>{{
                                            $t("pbudgets.tbl_hdr_category_id")
                                        }}</v-th>
                                        <v-th>{{
                                            $t("pbudgets.tbl_hdr_category_name")
                                        }}</v-th>
                                        <v-th class="text-right">{{
                                            $t("pbudgets.tbl_hdr_budget_amount")
                                        }}</v-th>
                                    </v-tr>
                                </v-thead>
                                <v-tbody>
                                    <v-tr v-for="(v, rk) in pd.data" :key="rk">
                                        <v-td>{{ v.voucher_category_id }}</v-td>
                                        <v-td
                                            :class="{
                                                'bg-danger text-white text-bold':
                                                    v.vcat === null
                                            }"
                                        >
                                            <template v-if="v.vcat === null">
                                                <i
                                                    class="far fa-exclamation-triangle"
                                                ></i>
                                                {{
                                                    $t(
                                                        "pbudgets.category_not_found"
                                                    )
                                                }}
                                            </template>
                                            <template v-else>{{
                                                v.vcat
                                            }}</template></v-td
                                        >
                                        <v-td class="text-right">{{
                                            $n(v.budget_amount, {
                                                style: "currency",
                                                currency: v.currency,
                                                currencyDisplay: "code"
                                            })
                                        }}</v-td>
                                    </v-tr>
                                </v-tbody>
                            </v-table>
                        </card>
                    </div>
                </template>
            </div>
            <div class="row card-wrapper">
                <div class="col-12">
                    <card>
                        <template slot="header"
                            >{{ $t("pbudgets.category_listing") }}
                            <a
                                href="/v1/voucher-categories/export-csv"
                                class="ml-3 btn btn-primary btn-sm btn-outline-primary"
                                ><i class="far fa-file-csv"></i>
                                {{ $t("pbudgets.download_csv") }}</a
                            ></template
                        >
                        <v-loader v-if="loading" :loading="loading" />
                        <template v-else>
                            <div class="row">
                                <div
                                    class="col-3"
                                    v-for="(v, k) in v_cats"
                                    :key="k"
                                >
                                    <div class="voucher-cat-box">
                                        {{ v.label }}
                                        <div
                                            class="small text-bold text-warning"
                                        >
                                            ID: {{ v.value }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.voucher-cat-box {
    margin-bottom: 25px;
    padding: 15px;
    border: 1px solid $gray-600;
    border-radius: 6px;
    font-size: 13px;
}
</style>
